import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { standUseMutation } from "../hooks";
import StandConst from "../stand-const";
import { EntityRemoveButton, Localize } from "components/service";
import { localizeByKey } from "components/service/localize";
import { TStand } from "../helpers/stand-types-helper";
import Icons from "components/icons";
import { usePermissionByObject } from "components/permissions";
import { useModelFormValidation } from "components/permissions";


interface IStandtActionFieldProps
{
  stand: TStand | undefined;
  variables: Record<string, any>;
  language: string;
}


const StandActionField: React.FC<IStandtActionFieldProps> = ({ stand, variables, language }) =>
{
  const navigate = useNavigate();

  // Permission hooks
  const { hasPermission: hasUpdateStandTypesPermission } = usePermissionByObject(StandConst.permissions.UPDATE);
  const { hasPermission: hasDeleteStandTypesPermission } = usePermissionByObject(StandConst.permissions.DELETE);
  const { validateUpdatePermission } = useModelFormValidation(StandConst);

  const { _setMutationStandDelete, loadingMutationStandDelete } =
    standUseMutation.delete(stand?.group_id, variables);

  const items = [
    {
      label: (
        <Tooltip title={!hasUpdateStandTypesPermission ? "Access denied: Update Stand Types" : ""}>
          <span style={{ opacity: hasUpdateStandTypesPermission ? 1 : 0.5 }}>
            <Localize>MENUS_DROP.Label_Edit</Localize>
          </span>
        </Tooltip>
      ),
      key: "1",
      icon: <Icons.Edit />,
      disabled: !hasUpdateStandTypesPermission,
      onClick: () => {
        if (validateUpdatePermission()) {
          navigate(
            `${StandConst.basePath}/edit/${stand?.group_id}/${language}`
          );
        }
      },
    },
    {
      key: "2",
      label: (
        <Tooltip title={!hasDeleteStandTypesPermission ? "Access denied: Delete Stand Types" : ""}>
          <span style={{ opacity: hasDeleteStandTypesPermission ? 1 : 0.5 }}>
            <EntityRemoveButton
              modalButton={
                <span style={{ display: "flex", alignItems: "center", width: 100 }}>
                  <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
                </span>
              }
              nameEntity={
                localizeByKey("ENTITY.Modal_Title_Stand")
              }
              dataNameEntity={stand?.title}
              loading={loadingMutationStandDelete}
              deleteMutation={(options) => {
                if (!hasDeleteStandTypesPermission) {
                  return Promise.reject(new Error('Access denied'));
                }
                return _setMutationStandDelete(options);
              }}
              variables={{
                group_id: stand?.group_id,
              }}
            />
          </span>
        </Tooltip>
      ),
      disabled: !hasDeleteStandTypesPermission,
    },
  ];

  return (
    <Dropdown
      // trigger={['click']}
      placement="bottomRight"
      menu={{ items }}
      overlayClassName="drop-more-menu"
      arrow
    >
      <EllipsisOutlined className="btn-more" />
    </Dropdown>
  );
};

export default StandActionField;
